import React, { useState } from 'react'
import {HashRouter as Router, Route, Routes} from 'react-router-dom'

import './index.css'
import Page from './components/Page'
import Map from './components/Map'
import EmbedMap from './components/EmbedMap'
import EmbedCode from './components/EmbedCode'

import { CONTENT } from './constants'
import { getCategoryCount } from './utils'

import About from './components/About'
import Resources from './components/Resources'
import SuggestUpdate from './components/SuggestUpdate'
import Chat from './components/Chat'
import MobileAppPrompt from './components/MobileAppPrompt'

const MOBILE_PROMPT_DISMISSED_KEY = 'mobile_web_prompt_dismissed'

const isPhoneDevice = () => {
  const ua = navigator.userAgent || ''
  const byUa = /Android|iPhone|iPod|IEMobile|Opera Mini|BlackBerry/i.test(ua)
  const byWidth = window.matchMedia && window.matchMedia('(max-width: 767px)').matches
  return byUa || byWidth
}

const isMapRoute = () => {
  const hashPath = (window.location.hash || '#/').replace(/^#/, '').split('?')[0] || '/'
  if (hashPath === '' || hashPath === '/') return true
  return /^\/\d+$/.test(hashPath)
}

function App({listings, metadata, apiUrl}) {
  const {ABOUT_TEXT, DISCLAIMER, VIDEO_TUTORIAL_LINK, RUBRIC_TEXT, CONTRIBUTORS, FORMS } = CONTENT 
  const resources = metadata.resources ?? null
  if (!metadata?.categoryCount) metadata.categoryCount = getCategoryCount(listings)

  const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '')
  const [ageGroupFilter, setAgeGroupFilter] = useState(hashParams.get('age_group') || 'Youth')
  const isEmbed = window.location.hash.startsWith('#/embed') && !window.location.hash.startsWith('#/embed-code')
  const shouldShowPromptOnLoad =
    !isEmbed &&
    isPhoneDevice() &&
    isMapRoute() &&
    window.sessionStorage.getItem(MOBILE_PROMPT_DISMISSED_KEY) !== '1'
  const [showMobilePrompt, setShowMobilePrompt] = useState(shouldShowPromptOnLoad)

  const handleContinueToWeb = () => {
    window.sessionStorage.setItem(MOBILE_PROMPT_DISMISSED_KEY, '1')
    setShowMobilePrompt(false)
  }

  if (isEmbed) {
    return (
      <Router>
        <Routes>
          <Route path="/embed" element={<EmbedMap listings={listings} metadata={metadata} />} />
          <Route path="/embed/:markerId" element={<EmbedMap listings={listings} metadata={metadata} />} />
        </Routes>
      </Router>
    )
  }

  if (showMobilePrompt) {
    return <MobileAppPrompt onContinue={handleContinueToWeb} />
  }

  return (
    <Router>
      <Page disclaimer={DISCLAIMER} aboutText={ABOUT_TEXT} resources={resources} ageGroupFilter={ageGroupFilter}>
        <Routes>
          {ABOUT_TEXT && <Route path="/about" element={
            <About aboutText={ABOUT_TEXT} contributors={CONTRIBUTORS} disclaimer={DISCLAIMER} videoLink={VIDEO_TUTORIAL_LINK} rubric={RUBRIC_TEXT} />}
          />}
          {resources && <Route path="/resources" element={<Resources resources={resources} />} />}
          <Route path="/chat" element={<Chat listings={listings} />} />
          <Route path="/embed-code" element={<EmbedCode />} />
          <Route path="/suggest" element={<SuggestUpdate forms={FORMS} metadata={metadata} apiUrl={apiUrl} listings={listings} />} />
          <Route path="/suggest/:listingId" element={<SuggestUpdate forms={FORMS} metadata={metadata} apiUrl={apiUrl} listings={listings} />} />
          <Route path="/" element={<Map listings={listings} metadata={metadata} ageGroupFilter={ageGroupFilter} setAgeGroupFilter={setAgeGroupFilter} />} />
          <Route path=":markerId" element={<Map listings={listings} metadata={metadata} ageGroupFilter={ageGroupFilter} setAgeGroupFilter={setAgeGroupFilter} />} />
        </Routes>
      </Page>
    </Router>
  )
}

export default App;
